<template>
    <div class="table-responsive">
        <!-- <h5>Late Fees</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>Applied:</b-th>
                    <b-th>Fee Applied:</b-th>
                    <b-th>Fee Waived:</b-th>
                    <b-th>Waived By:</b-th>
                    <b-th>Waived On:</b-th>
                    <b-th>Notes:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="list.length == 0 && !isLoading">
                <b-tr>
                    <b-td colspan="7"><i>No records available</i></b-td>
                </b-tr>
            </b-tbody>
            <b-tbody v-else>
                <b-tr v-for="item in list" :key="item.id">
                    <b-td> {{ _carbonDateDisplay(item.start_date) }}</b-td>
                    <b-td>{{ _toCurrency(item.charge_amount) }}</b-td>
                    <b-td>{{ _toCurrency(item.waive_amount * -1) }}</b-td>
                    <b-td>{{
                        item.waive_by ? item.waive_by.label : null
                    }}</b-td>
                    <b-td> {{ _carbonDateDisplay(item.waive_at) }}</b-td>
                    <b-td>{{ item.note }}</b-td>
                    <b-td class="text-right">
                        <i
                            v-if="
                                (invoice.status ==
                                    CBILLINGS.INVOICE.TYPE_OPEN ||
                                    invoice.status ==
                                        CBILLINGS.INVOICE.TYPE_LOCKED ||
                                    invoice.status ==
                                        CBILLINGS.INVOICE.TYPE_REOPENED) &&
                                _hasAccess('billing.invoice.update')
                            "
                            @click="showWaiveModal(item)"
                            class="cus-page-white-edit cursor-pointer"
                            :class="
                                isHasUsersChooseInvoice
                                    ? 'disabled cursor-not-allowed'
                                    : 'cursor-pointer'
                            "
                        ></i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />

        <modal-waive
            ref="modalWaive"
            :late-fee="selectedLateFee"
            @reload="reloadRelated"
        />
    </div>
</template>
<script>
import InvoiceLatefeesServices from "@/services/invoice/invoice-latefees";
import CBILLINGS from "@/constants/billings";
import Loader from "@/components/elements/loader-list";
import invoiceHelper from "@/mixins/invoice";
import { isEmpty } from "lodash";

export default {
    mixins: [invoiceHelper],
    components: {
        Loader,
        ModalWaive: () =>
            import("@/components/client-latefees/latefee-waive-modal")
    },
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    computed: {
        isHasUsersChooseInvoice() {
            return !isEmpty(
                this.$store.getters["billing/findUserChooseInvoice"](
                    this.invoice.id
                )
            );
        }
    },
    data() {
        return {
            CBILLINGS,
            list: [],
            isLoading: false,
            selectedLateFee: null,
            currentPage: 1,
            meta: null
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(page) {
            this.isLoading = true;
            this.list = [];
            let params = {
                page: page ? page : 1,
                perPage: this.PER_PAGE,
                type: CBILLINGS.BILLING_TYPE.LATE_FEES
            };

            InvoiceLatefeesServices.getLateFees(this.invoice.id, params)
                .then(response => {
                    this.isLoading = false;
                    if (response.message.code == 200) {
                        this.list = response.resources.map(item =>
                            this.prepareData(item)
                        );
                        this.meta = response.meta;
                    } else {
                        this._message(
                            "Error : Unable to get late fees list",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get late fees list",
                        "danger"
                    );
                    this.isLoading = false;
                    console.error(error);
                });
        },
        reloadRelated() {
            this.getList();
            this.$emit("reload-invoice-details");
        },
        setNegative(amount) {
            if (amount) {
                if (amount > 0) {
                    return amount * -1;
                }
            }

            return amount;
        },
        prepareData(item) {
            item.invoice = this.invoice;
            return item;
        },
        async showWaiveModal(lateFee) {
            if (this.isHasUsersChooseInvoice) {
                return;
            }

            let proceed = await this.checkInvoiceStatus(this.invoice.id, true);
            if (!proceed) {
                this.reloadRelated();
                return;
            }
            this.selectedLateFee = lateFee;
            this.$refs.modalWaive.open();
        }
    }
};
</script>
